export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-img5-37cfdd8314efaee930c623aaa254385d.jpg";